import React from "react";
import EditCar from "../conponents/car/edit";

export const EditCarPage = () => <EditCar />
